import { Component, OnInit } from '@angular/core';
import { ViewChild } from '@angular/core';
import { } from '@types/googlemaps';
import { Observable } from 'rxjs/Observable';
import { SaveMessageComponent } from '../../directive/save-message/save-message.component';
import { MatDialog } from '@angular/material';
import { Http } from '@angular/http';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AngularFirestore } from 'angularfire2/firestore';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})

export class ContactComponent implements OnInit {
  @ViewChild('gmap') gmapElement: any;
  map: google.maps.Map;
  marker: google.maps.Marker;
  updateModel: any = {};
  private subs = new Subscription();
  public mask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  constructor(private dialog: MatDialog,
    private afs: AngularFirestore,
    private http: Http,
    private httpclient: HttpClient
  ) { }

  getIpAdress(): Observable<any> {
    return this.http.get("https://api.bigadvice.com/helper/ip")
      .map(data => data.json());
  }

  joinUs(email) {
    if (email.replace(/\s/g, '') == '') {
      this.dialog.open(SaveMessageComponent, {
        width: '400px',
        data: {
          message: "E-posta adresini yazmalısın!",
          type: "update"
        }
      });
      return;
    }
    this.subs = this.getIpAdress().subscribe(data => {
      this.afs.collection('newsLetter').add({
        email: email,
        modifyDate: Date.now(),
        ipAdress: data
      }).then(() => {
        this.dialog.open(SaveMessageComponent, {
          width: '400px',
          data: {
            message: "Bilgilerin iletilmiştir, teşekkürler.",
            type: "update"
          }
        });
      });
    });

  }

  setMapType(mapTypeId: string) {
    this.map.setMapTypeId(mapTypeId);

  }
  request(option) {

    const sub = this.httpclient.post('https://api.bigadvice.com/email/sendInfo', option.data)
      .subscribe((res) => {
        if (res === "OK") {
          sub.unsubscribe();
        }
      });
  }

  setCenter() {
    this.map.setCenter(new google.maps.LatLng(41.114309, 29.02393200000006));
  }

  send(ngForm: NgForm) {
    let form = ngForm.value
    let contactForm = {
      firstname: form.firstname ? form.firstname : "",
      lastname: form.lastname ? form.lastname : "",
      phone: form.phone ? form.phone : "",
      email: form.email ? form.email : "",
      message: form.message ? form.message : "",
      isSeen: false,
      modifyDate: Date.now()
    };
    const option = {
      data: {
        firstname: form.firstname ? form.firstname : "",
        lastname: form.lastname ? form.lastname : "",
        phone: form.phone ? form.phone : "",
        email: form.email ? form.email : "",
        message: form.message ? form.message : ""
      }
    }
    this.request(option);
    this.afs.collection('contactForms').add(contactForm);
    this.dialog.open(SaveMessageComponent, {
      width: '400px',
      data: {
        message: "Bilgilerin iletilmiştir, teşekkürler.",
        type: "update"
      }
    });
    ngForm.reset();
  }

  ngOnInit() {

    var mapProp = {
      center: new google.maps.LatLng(41.114309, 29.02393200000006),
      zoom: 15,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      marker: this.marker
    };
    this.map = new google.maps.Map(this.gmapElement.nativeElement, mapProp);
    this.marker = new google.maps.Marker({
      position: new google.maps.LatLng(41.114309, 29.02393200000006),
      map: this.map,
      title: 'Vision Enterpreneurship (Vizyon Girişimcilik)'
    });
  }
  ngOnDestroy() {
    this.subs.unsubscribe();

  }

}


// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/corporate/contact/contact.component.ts